import React from 'react';
import PropTypes from 'prop-types';

const renderBodyItem = (item, index) => {
  switch (item.type) {
    case 'text':
      return (
        <p key={index} className="vads-u-margin-y--1">
          {item.value}
        </p>
      );
    case 'phone':
      return (
        <p
          key={index}
          className="vads-u-margin-y--1 vads-u-display--flex vads-u-align-items--center vads-u-font-weight--normal"
        >
          <va-telephone contact={item.value} />
          {item.tty && (
            <>
              &nbsp;&nbsp;(
              <va-telephone contact="711" tty />)
            </>
          )}
        </p>
      );
    case 'link':
      return (
        <p key={index} className="vads-u-margin-y--1">
          <va-link href={item.url} text={item.value} />
        </p>
      );
    default:
      return null;
  }
};

export const DynamicVeteranStatusAlert = ({ alertType, body, header }) => {
  return (
    <va-alert
      class="vads-u-margin-bottom--4"
      close-btn-aria-label="Close notification"
      status={alertType || 'warning'}
      visible
    >
      {header && <h2 slot="headline">{header}</h2>}
      <div>{body?.map((item, index) => renderBodyItem(item, index))}</div>
    </va-alert>
  );
};

DynamicVeteranStatusAlert.propTypes = {
  alertType: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  body: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['text', 'phone', 'link']),
      url: PropTypes.string,
      value: PropTypes.string,
      tty: PropTypes.bool,
    }),
  ),
  header: PropTypes.string,
};
